import script from "./pay-product-block.vue?vue&type=script&lang=ts&setup=true"
export * from "./pay-product-block.vue?vue&type=script&lang=ts&setup=true"

import "./pay-product-block.vue?vue&type=style&index=0&id=317458d4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317458d4"]])

export default __exports__